import { render, staticRenderFns } from "./Passwd.vue?vue&type=template&id=d1d588a8&scoped=true"
import script from "./Passwd.vue?vue&type=script&lang=js"
export * from "./Passwd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1d588a8",
  null
  
)

export default component.exports